import React from 'react';
import styled, { css } from 'styled-components';
import { useInView } from 'react-intersection-observer';

const Wrapper = styled.div`
  transition: opacity 0.9s ease ${({ $delay }) => $delay || 0}ms,
              transform 0.9s ease ${({ $delay }) => $delay || 0}ms;

  ${({ $direction, $visible }) => {
    if (!$visible) {
      if ($direction === 'left') return css`opacity: 0; transform: translateX(-50px);`;
      if ($direction === 'right') return css`opacity: 0; transform: translateX(50px);`;
      if ($direction === 'scale') return css`opacity: 0; transform: scale(0.92);`;
      return css`opacity: 0; transform: translateY(40px);`;
    }
    return css`opacity: 1; transform: translate(0) scale(1);`;
  }}
`;

export default function AnimatedSection({ children, direction = 'up', delay = 0, threshold = 0.12 }) {
  const { ref, inView } = useInView({ threshold, triggerOnce: true });
  return (
    <Wrapper ref={ref} $visible={inView} $direction={direction} $delay={delay}>
      {children}
    </Wrapper>
  );
}
